import React, { useCallback, useRef, useMemo } from 'react';
import { Translator } from 'react-auto-translate';
import { useSelector } from 'react-redux';
import config from 'src/config';

const TranslationProvider = ({ children }) => {
	const languageState = useSelector((state) => state.languages.value);

	// ✅ persistent cache
	const languageCache = useRef({});

	// get(key, language)
	const getLanguageCache = useCallback((key, language) => {
		return languageCache.current[key]?.[language];
	}, []);

	// set(key, language, value)
	const setLanguageCache = useCallback((key, language, value) => {
		if (!languageCache.current[key]) {
			languageCache.current[key] = {};
		}

		languageCache.current[key][language] = value;
	}, []);

	const cacheProvider = useMemo(
		() => ({
			get: getLanguageCache,
			set: setLanguageCache,
		}),
		[getLanguageCache, setLanguageCache],
	);

	return (
		<Translator
			cacheProvider={cacheProvider}
			from="en"
			to={languageState}
			googleApiKey={config.googleTranslateApiKey}
		>
			{children}
		</Translator>
	);
};

export default TranslationProvider;
